import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { useDocumentTitle } from 'usehooks-ts'
import { BrowserRouter } from "react-router-dom";

import { ConfigProvider } from 'antd';
import ptPT from 'antd/es/locale/pt_PT';

import App from "./App";
import './i18n';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// https://coolors.co/f02400-2b2074-f2e145-e3bfbf-31c4c4
const colors = {
  CandyAppleRed: 'hsla(9, 100%, 47%, 1)',
  MidnightBlue: 'hsla(248, 57%, 29%, 1)',
  MinionYellow: 'hsla(54, 87%, 61%, 1)',
  BabyPink: 'hsla(0, 39%, 82%, 1)',
  MaximumBlueGreen: 'hsla(180, 60%, 48%, 1)',
}

const theme={
  token: {
    colorPrimary: 'hsla(24, 100%, 12%, 1)',
    radiusBase:3
  },
};

root.render(
  <ConfigProvider locale={ptPT} theme={theme}>
    <App />
  </ConfigProvider>
);
